exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.switchEdit {\n  display: inline-block;\n  margin: 0.5ex 1ex;\n  padding: 0.5ex 1ex;\n  border: 2px solid black;\n  border-radius: 12px;\n}\n\ndiv.br {\n  margin-top:0.6ex;\n  text-align:center;\n}\n\ndiv.br button {\n  min-width: 80px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/criterion-summary/criterion-summary.component.css
// module id = 382
// module chunks = 0